import React, {useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import {AddNewActivityModal} from '../views/AddNewActivityModal'
import {AddInvestorUserModal} from '../../investor-database/view/AddInvestorUserModal'
import '../styles/InvestorCrm.scss'

export const Contacts = ({
  investorUsers,
  investorId,
  getInvestor,
  getActivity,
  roundId,
  investorName,
}: {
  investorUsers: []
  investorId: number
  getInvestor: () => void
  getActivity: () => void
  roundId?: number
  investorName: string
}) => {
  const {formatMessage} = useIntl()
  const [activityModalShow, setActivityModalShow] = useState(false)
  const [modalShow, setModalShow] = React.useState(false)
  const [selectedInvestorUser, setSelectedInvestorUser] = useState<{label: string; value: number}>()
  return (
    <>
      <div className='contacts-container flex-wrap justify-content-around gap-3'>
        <div className='card bg-transparent p-0 card-sm-grow contact-card-crm'>
          <div className='bg-white p-5 rounded d-flex flex-column align-items-center justify-content-between gap-4 contact-card-crm-inner w-100 col-3'>
            <div>
              <img
                src={toAbsoluteUrl('/media/icons/investor/user_icon_with_background.svg')}
                alt='User icon'
              />
            </div>
            <div className='w-100'>
              <BasicButton
                onClick={() => setModalShow(true)}
                buttonText={formatMessage({id: 'Add New Contact Person'})}
                border='none'
                color='#4776E6'
                textColor='#FFFFFF'
                customClass='py-3'
                width='100'
              />
            </div>
          </div>
        </div>
        {investorUsers?.map((contact: any, index) => (
          <div
            className={`card bg-transparent p-0 card-sm-grow contact-card-crm`}
            key={contact.investorUserId}
          >
            <div className='bg-white d-flex flex-column justify-content-between p-5 rounded gap-4 contact-card-crm-inner'>
              <div className='d-flex '>
                <div className='me-4'>
                  <DisplayImage
                    imgName={contact?.file?.name}
                    alt='User icon'
                    height='76px'
                    width='76px'
                    fit='contain'
                  />
                </div>
                <div className='d-flex flex-column text-color-dark-mode'>
                  <p className='font-size-16 fw-bold mb-1 dark_text_color'>{contact.name}</p>
                  <p className='font-size-12 fw-semibold mb-1 dark_text_color'>
                    {contact.designation}
                  </p>
                  <p className='font-size-13 text-muted text-break dark_text_color'>
                    {contact.email}
                  </p>
                </div>
              </div>
              <div>
                <BasicButton
                  buttonText={formatMessage({id: 'Add Activity'})}
                  border='none'
                  color='#4776E6'
                  textColor='#FFFFFF'
                  customClass='py-3'
                  width='100'
                  onClick={() => {
                    setSelectedInvestorUser({label: contact.name, value: contact.investorUserId})
                    setActivityModalShow(true)
                  }}
                />
                {/* <button className='btn btn-primary btn-active-primary button-container fs-6 py-2 fw-normal'>
                  {formatMessage({id: 'Add Activity'})}
                </button> */}
              </div>
            </div>
          </div>
        ))}
      </div>
      <AddNewActivityModal
        investorName={investorName}
        modalShow={activityModalShow}
        setModalShow={setActivityModalShow}
        investorId={investorId}
        getActivity={getActivity}
        selectedInvestorUser={selectedInvestorUser}
        roundId={roundId}
      />
      <AddInvestorUserModal
        userModalShow={modalShow}
        setUserModalShow={setModalShow} 
        id={investorId?.toString()}
        getInvestor={getInvestor}
      />
    </>
  )
}
